import React from 'react';
import { Coins, DollarSign } from 'lucide-react';
import BigNumber from 'bignumber.js';

interface BalanceGridProps {
  tokens: number;
  wei: BigNumber;
  eth: string;
  ethCad: number | null;
  ethPrice: number | null;
}

export function BalanceGrid({ tokens, wei, eth, ethCad, ethPrice }: BalanceGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="bg-blue-900/20 rounded-lg p-4 border border-blue-500/20">
        <div className="flex items-center gap-2 mb-2">
          <Coins className="text-blue-400" size={20} />
          <span className="text-blue-300">Tokens</span>
        </div>
        <p className="text-2xl font-bold text-white">{tokens.toLocaleString()}</p>
      </div>

      <div className="bg-purple-900/20 rounded-lg p-4 border border-purple-500/20">
        <div className="flex items-center gap-2 mb-2">
          <Coins className="text-purple-400" size={20} />
          <span className="text-purple-300">WEI</span>
        </div>
        <p className="text-2xl font-bold text-white">{wei.toFormat()}</p>
      </div>

      <div className="bg-green-900/20 rounded-lg p-4 border border-green-500/20">
        <div className="flex items-center gap-2 mb-2">
          <Coins className="text-green-400" size={20} />
          <span className="text-green-300">ETH</span>
        </div>
        <p className="text-2xl font-bold text-white">
          {Number(eth).toFixed(8)} ETH
          {ethCad && (
            <span className="block text-sm text-green-400 mt-1">
              ≈ ${ethCad.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} CAD
            </span>
          )}
        </p>
      </div>

      <div className="bg-yellow-900/20 rounded-lg p-4 border border-yellow-500/20">
        <div className="flex items-center gap-2 mb-2">
          <DollarSign className="text-yellow-400" size={20} />
          <span className="text-yellow-300">Exchange Rate</span>
        </div>
        <p className="text-2xl font-bold text-white">
          1 ETH = 
          <span className="text-yellow-400 ml-2">
            ${ethPrice?.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} CAD
          </span>
        </p>
      </div>
    </div>
  );
}